<template>
  <!-- 职位收藏 -->
  <div class="box">
    <div
      class="container"
      v-for="(item, index) in listArr"
      :key="index"
      @click="handelClickJob(item)"
    >
      <!-- 兼职/全职 -->
      <div class="and-all">
        <div :class="item.jobType == 1 ? 'full-time' : 'Part-time'"></div>
      </div>
      <div class="details">
        <div class="Position cen-box">
          <!-- 职位名 -->
          <div class="PositionName">{{ item.positionName }}</div>
          <!-- 聊天icon -->
          <div class="chat-icon firm-clickable" @click.stop="handelChat(item)"></div>
          <!-- 收藏icon -->
          <div class="Collect firm-clickable" @click.stop="handelCollect(item)"></div>
          <!-- 薪资 -->
          <div class="pay">{{ item.salaryRange }}</div>
        </div>
        <!-- 地址 -->
        <div class="address cen-box">地址：{{ item.workAddress }}</div>
      </div>
      <!-- 公司logo  公司名 -->
      <div class="corporation-name">
        <div class="corporation-box">
          <img :src="item.logoImg" alt="" />
          <p class="firm-clickable" @click.stop="handelSkip(item)">{{ item.companyName }}</p>
        </div>
      </div>
    </div>
    <JobDetails
      :dialogVisible="dialogVisible"
      :PositionId="PositionId"
      :dataItem="dataItem"
      :data="data"
      @handleClose="handleClose"
      @handelCollect="handelCollect"
      @handelChat="onJobDetailsHandelChat"
    ></JobDetails>
    <!-- 索要联系方式 -->
    <ContactInformation
      :VisibleContact="VisibleContact"
      :row="rowObj"
      :DataObj="DataObj"
      @handleCloseUp="VisibleContact = false"
      @handleConContact="handleConContact"
    ></ContactInformation>
  </div>
</template>

<script>
import {
  getPositionInfoById, // 职位详情
} from "../../../../../../assets/api/Recommended";
// 引入职位详情弹窗
import JobDetails from "../../../../home/components/homes/JobDetails.vue";
// 引入索要联系方式弹窗
import ContactInformation from "../../../../home/components/homes/ContactInformation.vue";
// 引入职位收藏页的接口
import {
  cancelPositionCollect, // 取消职位收藏
} from "../../../../../../assets/api/CentreCollect";
export default {
  watch: {},
  // 组件名称
  name: "Login",
  // 组件参数 接收来自父组件的数据
  props: {
    listArr: {},
  },
  // 局部注册的组件
  components: { JobDetails, ContactInformation },
  // 组件状态值
  data() {
    return {
      dialogVisible: false, //职位详情
      PositionId: "", // 职位id
      data: {}, //传给详情弹窗的详情
      dataItem: {}, //被点击职位的本身数据
      VisibleContact: false, //索要联系方式弹窗
      rowObj: {
        companyId: "", //公司id
        companyName: "", //企业名称
        targetPositionId: "", //职位id
        targetPositionName: "", //职位名称
      }, //数据
      DataObj: {}, //点击索要联系方式被点击职位的信息
    };
  },
  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    //点击确认索要
    handleConContact() {
      this.$emit("Refresh");
      this.VisibleContact = false;
    },
    // 点击职位 打开职位详情弹窗
    handelClickJob(item) {
      // 收藏列表中的职位必然已收藏；列表接口往往不带 hasCollect，需显式带上供详情弹窗展示
      this.dataItem = { ...item, hasCollect: true };
      // 点击职位跳转推荐职位  并传val val中包含职位id
      this.PositionId = item.positionId;
      var data = {
        data: {
          positionId: item.positionId,
        },
      };
      getPositionInfoById(data).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
          this.dialogVisible = true;
        } else {
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = !this.dialogVisible;
    },

    // 点击企业名称 跳转公司详情
    handelSkip(item) {
      this.$router.push({
        path: "/ComDetails",
        query: { key: item.companyId, select: 1 },
      });
    },
    // 点击聊天icon
    handelChat(item) {
      this.DataObj = item;
      this.rowObj.companyId = item.companyId;
      this.rowObj.companyName = item.companyName;
      this.rowObj.targetPositionId = item.id;
      this.rowObj.targetPositionName = item.positionName;
      this.VisibleContact = true;
      console.log(item);
    },
    // 职位详情弹窗内「立即沟通」
    onJobDetailsHandelChat(payload) {
      if (!payload) return;
      this.DataObj = payload.dataObj;
      this.rowObj.companyId = payload.companyId;
      this.rowObj.companyName = payload.companyName;
      this.rowObj.targetPositionId = payload.targetPositionId;
      this.rowObj.targetPositionName = payload.targetPositionName;
      this.VisibleContact = true;
    },
    // 点击收藏 /取消收藏
    handelCollect(item) {
      this.dialogVisible = false;
      this.$emit("handelCollect", item);
    },
  },
};
</script>

<style scoped lang="less">
.box {
  // width: 1184px;
  width: 820px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .container:hover {
    box-shadow: 0px 0px 6px 1px rgba(50, 145, 248, 0.8);
  }
  // 每个职位推荐的大div
  .container {
    width: 390px;
    height: 136px;
    box-sizing: border-box;
    margin-top: 15px;
    margin-right: 15px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    cursor: pointer;

    // 兼职全职style
    .and-all {
      width: 100%;
      height: 20px;
      .full-time {
        width: 30px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/quanzhi@3x.svg");
        background-size: 100% 100%;
      }
      .Part-time {
        width: 30px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/jianzhi@3x.svg");
        background-size: 100% 100%;
      }
    }
    // 主体 职位名称  聊天icon 收藏icon 地址 薪资 style
    .details {
      width: 345px;
      height: 64px;
      margin: 0 auto;
      border-bottom: 1px solid #cccccc;
      font-family: PingFangSC-Medium;
      font-weight: 400;
      .cen-box {
        width: 345px;
        height: 21px;
        line-height: 21px;
        // display: flex;
      }
      .Position {
        margin-top: 3px;
        display: flex;
        position: relative;
        .PositionName {
          min-width: 80px;
          max-width: 160px;
          font-size: 16px;
          color: #409eff ;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .chat-icon {
          width: 22px;
          height: 18px;
          margin: auto 0;
          margin-left: 15px;
          background-image: url("../../../../../../assets/imgs/zaixiangoutong@3x.svg");
          background-size: 100% 100%;
        }
        .Collect {
          width: 22px;
          height: 18px;
          margin: auto 0;
          margin-left: 10px;
          background-image: url("../../../../../../assets/imgs/shoucang@3x.svg");
          background-size: 100% 100%;
        }
        .NotCollect {
          width: 22px;
          height: 18px;
          margin: auto 0;
          margin-left: 10px;
          background-image: url("../../../../../../assets/imgs/shoucang-null@3x.svg");
          background-size: 100% 100%;
        }
        // 薪资 style
        .pay {
          // width: 100px;
          flex: 1;
          font-family: PingFang-SC-Bold;
          font-size: 16px;
          color: #fe574a;
          text-align: right;
          font-weight: 700;
        }
      }
      // 地址 style
      .address {
        width: 345px;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 13px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    // 公司logo 公司名 style
    .corporation-name {
      min-width: 345px;
      height: 48px;
      margin: 0 auto;
      display: flex;
      .corporation-box {
        width: 100%;
        height: 24px;
        line-height: 24px;
        margin: auto;
        display: flex;
        img {
          width: 24px;
          height: 24px;
        }
        p:hover {
          color: #f8b3b3;
        }
        p {
          font-family: PingFangSC-Medium;
          font-size: 13px;
          color: #333300;
          font-weight: 400;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
  }

  // .container:nth-child(2n + 1) {
  //   margin-left: 0px;
  // }

  // .container:nth-child(1) {
  //   margin-top: 0px;
  // }
  // .container:nth-child(2) {
  //   margin-top: 0px;
  // }
}
</style>
